import type { FC, ReactNode } from 'react'
import type { Tone } from '@/components/generals/arcade'

import { cn } from '@/lib/utils'
import { ABOUT } from '@/components/landing/about/data'

import {
    ARC,
    IconTile,
    PixelPanel,
    StageTitle
} from '@/components/generals/arcade'

const TONES: Tone[] = ['tan', 'sage', 'peach']

const Achievements: FC = (): ReactNode => {
    return (
        <section id='achievements' className={ARC.section} aria-labelledby='achievements-title'>
            <StageTitle
                stage="Stage 03"
                title="Achievements unlocked"
                id='achievements-title'
                intro={ABOUT.achievementsIntro}
            />

            <ul className='m-0 grid list-none gap-7 p-0 sm:grid-cols-2 lg:grid-cols-3'>
                {ABOUT.achievements.map((a, i) => (
                    <li key={a.label} className='flex min-w-0'>
                        <PixelPanel size='sm' className='min-w-0 flex-1'>
                            <div className='flex h-full flex-col gap-2.5 p-6 md:p-7'>
                                <div className='flex items-center justify-between gap-3'>
                                    <IconTile name='trophy' tone={TONES[i % TONES.length]} />
                                    <span
                                        className={cn(
                                            ARC.pixel,
                                            'bg-(--cab-sage) px-2 py-1 text-[10px] tracking-[0.06em] shadow-[inset_0_0_0_2px_var(--cab-plum)]'
                                        )}
                                    >
                                        Unlocked
                                    </span>
                                </div>
                                <p className={cn(ARC.outline, 'm-0 mt-2 text-[34px] leading-none md:text-[42px]')}>{a.value}</p>
                                <h3 className={cn(ARC.pixel, 'm-0 mt-1 text-[13px] leading-snug tracking-[0.06em]')}>{a.label}</h3>
                                <p className='m-0 text-[15px] leading-normal'>{a.note}</p>
                            </div>
                        </PixelPanel>
                    </li>
                ))}
            </ul>
        </section>
    )
}

export default Achievements
